module.exports = __webpack_public_path__ + "static/media/home.212d7dc3.svg";